import React from 'react';
import {
  TextField,
  FormControl,
  Grid,
  FormHelperText,
} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';
import {STATE} from '../../constants/Lookup';
import {PhoneMaskCustom} from '../../util/PhoneMaskFormat';
function POEInformation({
  classes,
  control,
  setValue,
  errors,
  getValues,
  handleGetData,
  dropDownData,
}) {
  return (
    <Grid container spacing={2} className="new-standard-textfields">
      {/* POE name */}
      <div className="col-md-4 col-sm-4 col-xl-3 form-group">
        <FormControl variant="outlined" fullWidth>
          <Controller
            render={({value, onChange}) => (
              <TextField
                className={`${classes.labelName}`}
                placeholder="Enter POE Name"
                margin="dense"
                name="POEName"
                variant="outlined"
                label="POE Name"
                value={value}
                onChange={onChange}
                error={Boolean(errors.POEName?.message)}
                fullWidth
              />
            )}
            control={control}
            name="POEName"
          />
        </FormControl>
        <FormHelperText variant="outlined">
          {errors.POEName?.message ? errors.POEName.message : ''}
        </FormHelperText>
      </div>
      {/* POE Address 1 */}
      <div className="col-md-4 col-sm-4 col-xl-3 form-group">
        <FormControl variant="outlined" fullWidth>
          <Controller
            render={({value, onChange}) => (
              <TextField
                className={`${classes.labelName}`}
                placeholder="Enter Address Line 1"
                margin="dense"
                name="POEAddressLine1"
                variant="outlined"
                label="Address Line 1"
                value={value}
                onChange={onChange}
                error={Boolean(errors.POEAddressLine1?.message)}
                fullWidth
              />
            )}
            control={control}
            name="POEAddressLine1"
          />
        </FormControl>
        <FormHelperText variant="outlined">
          {errors.POEAddressLine1?.message ? errors.POEAddressLine1.message : ''}
        </FormHelperText>
      </div>
      {/* POE Address 2 */}
      <div className="col-md-4 col-sm-4 col-xl-3 form-group">
        <FormControl variant="outlined" fullWidth>
          <Controller
            render={({value, onChange}) => (
              <TextField
                className={`${classes.labelName}`}
                placeholder="Enter Address Line 2"
                margin="dense"
                name="POEAddressLine2"
                variant="outlined"
                label="Address Line 2"
                value={value}
                onChange={onChange}
                error={Boolean(errors.POEAddressLine2?.message)}
                fullWidth
              />
            )}
            control={control}
            name="POEAddressLine2"
          />
        </FormControl>
        <FormHelperText variant="outlined">
          {errors.POEAddressLine2?.message ? errors.POEAddressLine2.message : ''}
        </FormHelperText>
      </div>
      {/* Patient Phone */}
      <div className="col-md-4 col-sm-4 col-xl-3 form-group">
        <FormControl variant="outlined" fullWidth>
          <Controller
            render={({value, onChange}) => (
              <TextField
                className={`${classes.labelName}`}
                placeholder="Enter Phone"
                margin="dense"
                name="Phone"
                variant="outlined"
                label="Phone"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                error={Boolean(errors.POEPhone?.message)}
                InputProps={{
                  inputComponent: PhoneMaskCustom,
                }}
                fullWidth
              />
            )}
            control={control}
            name="POEPhone"
          />
        </FormControl>
        <FormHelperText variant="outlined">
          {errors.POEPhone?.message ? errors.POEPhone.message : ''}
        </FormHelperText>
      </div>
      {/* POE City */}
      <div className="col-md-4 col-sm-4 col-xl-3 form-group">
        <FormControl variant="outlined" fullWidth>
          <Controller
            render={({value, onChange}) => (
              <TextField
                className={`${classes.labelName}`}
                placeholder="Enter City"
                margin="dense"
                name="POECity"
                variant="outlined"
                label="City"
                value={value}
                onChange={onChange}
                error={Boolean(errors.POECity?.message)}
                fullWidth
              />
            )}
            control={control}
            name="POECity"
          />
        </FormControl>
        <FormHelperText variant="outlined">
          {errors.POECity?.message ? errors.POECity.message : ''}
        </FormHelperText>
      </div>
      {/* POE State */}
      <div className="col-md-4 col-sm-4 col-xl-3 form-group">
        <FormControl margin="dense" variant="outlined" fullWidth>
          <Controller
            render={(props) => (
              <GuiAutoComplete
                {...props}
                classes={{
                  popper: classes.popper,
                  option: classes.option,
                }}
                id="POEState"
                options={handleGetData(dropDownData, STATE)}
                size="small"
                value={props.value}
                autoHighlight
                getOptionDisabled={(option) => option.valueCode === null}
                getOptionLabel={(option) => {
                  return option && option.valueCode && option.value ?
                    option.valueCode + ' - ' + option.value :
                    option.value === null ?
                      option.valueCode :
                      '';
                }}
                renderInput={(params) => (
                  <GuiTextField
                    {...params}
                    variant="outlined"
                    fullWidth
                    className={` ${classes.labelName}`}
                    label="State"
                    name="POEState"
                    placeholder="Select State"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'off',
                    }}
                  />
                )}
                onChange={(_, data) => {
                  props.onChange(data);
                }}
              />
            )}
            name="POEState"
            control={control}
          />
        </FormControl>
        <FormHelperText variant="outlined">
          {errors.POEState?.message ? errors.POEState.message : ''}
        </FormHelperText>
      </div>
      {/* POE Zip */}
      <div className="col-md-4 col-sm-4 col-xl-3 form-group">
        <FormControl variant="outlined" fullWidth>
          <Controller
            render={({value, onChange}) => (
              <TextField
                value={value}
                className={`${classes.labelName}`}
                placeholder="Enter Zip"
                margin="dense"
                name="POEZip"
                variant="outlined"
                label="Zip"
                error={Boolean(errors.POEZip?.message)}
                onChange={(e) => {
                  if (Number(e.target.value) || e.target.value === '') {
                    onChange(e.target.value);
                  }
                }}
                fullWidth
              />
            )}
            control={control}
            name="POEZip"
          />
        </FormControl>
        <FormHelperText variant="outlined">
          {errors.POEZip?.message ? errors.POEZip.message : ''}
        </FormHelperText>
      </div>
    </Grid>
  );
}

export default POEInformation;
